export default "__VITE_ASSET__2dc14a2a__"